// DronePage.jsx
import React from "react";
import { Link } from "react-router-dom";
import "./Railwaycrauzet.css";

import bombShell from "../Assessts/CrouzetImages/1DCmotors.png";
import universalTestRig from "../Assessts/CrouzetImages/2brushesmotors.png";
import universalTestRi from "../Assessts/CrouzetImages/3brushlessmotors.png";
import universalTestR from "../Assessts/CrouzetImages/4Gearbox_brakes.png";
import universalTest from "../Assessts/CrouzetImages/5DCstepper.png";
import universalTes from "../Assessts/CrouzetImages/6Actuaters.png";
import universalTe from "../Assessts/CrouzetImages/7MicroSwitches.png";
import universalT from "../Assessts/CrouzetImages/8Monitoring_Sensor.png";
import universal from "../Assessts/CrouzetImages/9TimerRelays.png";
import universa from "../Assessts/CrouzetImages/10limitSwitches.png";
import univers from "../Assessts/CrouzetImages/11Monitoring_relays.png";
import univer from "../Assessts/CrouzetImages/12Hermetically_sealed_relays.png";

import unive from "../Assessts/CrouzetImages/13SolidState_Relays.png";
import univ from "../Assessts/CrouzetImages/14Thermal_Circuit_Breaker.png";
import uni from "../Assessts/CrouzetImages/15Electrical_Distributed_panel.png";
import un from "../Assessts/CrouzetImages/16Pilot_force_feel.png";
import u from "../Assessts/CrouzetImages/17buttons.png";
import ua from "../Assessts/CrouzetImages/18Side_stick_controllers.png";

const crauzetProducts = [
  {
    id: 1,
    title: "DC Motors",
    img: bombShell,
    desc: " DC Motors are engineered for high precision and reliable control. They deliver smooth motion and consistent torque under demanding conditions. With compact designs and multiple voltage options, they suit diverse industrial needs. These motors ensure long service life and efficiency across automation systems."
  },
  {
    id: 2,
    title: "Brushed Motors",
    img: universalTestRig,
    desc: " Brushed DC Motors combine simplicity with powerful performance. Designed for easy integration, they offer stable speed control and reliable operation. These motors are widely used in automation, medical devices, and control systems. Their durability makes them a cost-effective choice for continuous applications."
  },
  {
    id: 3,
    title: "Brushless Motors",
    img: universalTestRi,
    desc: " Brushless Motors provide exceptional energy efficiency and long lifespan. They operate with minimal maintenance and generate low noise levels. Perfect for robotics, automation, and precision control systems. Their compact and lightweight design ensures smooth and accurate motion control."
  },
  {
    id: 4,
    title: "Gearboxes & Brakes",
    img: universalTestR,
    desc: " Gearboxes and Brakes ensure accurate torque conversion and motion control. They deliver dependable speed reduction and braking for critical machinery. Designed for seamless integration with Crouzet motors. Built for endurance, they perform reliably in industrial and automation setups."
  },
  {
    id: 5,
    title: "Stepper Motors",
    img: universalTest,
    desc: " Stepper Motors offer precise positioning and excellent repeatability. They are ideal for robotics, automation, and instrumentation systems. The motors provide controlled movement without feedback systems. Their accuracy and dependability make them vital in process automation."
  },
  {
    id: 6,
    title: "Actuators",
    img: universalTes,
    desc: " Actuators deliver precise linear or rotary motion in compact assemblies. They are suitable for aerospace, medical, and industrial environments. Built for reliability, they ensure consistent performance in critical tasks. Each actuator guarantees smooth operation and long-term durability."
  },
  {
    id: 7,
    title: "Micro Switches",
    img: universalTe,
    desc: " Micro Switches are designed for accurate detection and control feedback. They provide reliable operation even in harsh conditions. With long mechanical life, they are ideal for safety and automation systems. Their compact build ensures easy installation in complex assemblies."
  },
  {
    id: 8,
    title: "Monitoring Sensors",
    img: universalT,
    desc: " Monitoring Sensors ensure continuous supervision of voltage, current, and temperature. They help maintain system protection and stability. Designed for high sensitivity and precision in industrial applications. These sensors enhance efficiency by preventing equipment downtime."
  },
  {
    id: 9,
    title: "Timer Relays",
    img: universal,
    desc: "Timer Relays offer accurate time control for automation processes. They are used in industrial machinery, lighting, and energy systems. Configurable and reliable, they optimize operational timing and safety. Compact design and high precision make them ideal for control panels."
  },
  {
    id: 10,
    title: "Limit Switches",
    img: universa,
    desc: "Limit Switches provide precise position detection and mechanical control. They are rugged and suitable for industrial or aerospace use. Designed for reliability under vibration and harsh conditions. These switches enhance safety and accuracy in automated processes."
  },
  {
    id: 11,
    title: "Monitoring Relays",
    img: univers,
    desc: " Monitoring Relays safeguard electrical systems by detecting anomalies. They monitor phase loss, overloads, and voltage imbalance. Designed to prevent costly downtime and ensure consistent operation. Their reliability makes them essential for automated and power systems."
  },
  {
    id: 12,
    title: "Hermetically Sealed Relays",
    img: univer,
    desc: " Hermetically Sealed Relays perform flawlessly in extreme environments. Resistant to shock, vibration, and contamination, they ensure reliability. Ideal for aerospace, defense, and critical industrial systems. Each unit delivers unmatched performance and long service life."
  },
  {
    id: 13,
    title: "Solid State Relays",
    img: unive,
    desc: " Solid State Relays offer fast, silent, and reliable switching. They eliminate mechanical wear and ensure long-lasting operation. Perfect for high-cycle industrial and automation applications. Compact, efficient, and durable for continuous electrical control."
  },
  {
    id: 14,
    title: "Thermal Circuit Breakers",
    img: univ,
    desc: "Thermal Circuit Breakers protect circuits from overload and short faults. Designed for easy reset and dependable safety performance. They provide consistent protection in electrical distribution systems. Ideal for machinery, control panels, and industrial use."
  },
  {
    id: 15,
    title: "Electrical Distribution Panels",
    img: uni,
    desc: " Electrical Distribution Panels ensure organized and safe power management. Built for industrial and commercial environments requiring reliability. Modular designs allow flexible configuration and expansion. They deliver efficient and secure electrical distribution systems."
  },
  {
    id: 16,
    title: "Pilot Force Feel Units",
    img: un,
    desc: "Pilot Force Feel Units replicate realistic control sensations for simulators. Engineered with precision for aerospace and defense systems. They enhance training realism by providing tactile feedback. Durable construction ensures long-term performance and accuracy."
  },
  {
    id: 17,
    title: "Push Buttons & Control Switches",
    img: u,
    desc: "Push Buttons and Switches deliver reliable tactile response and durability. Ergonomically designed for industrial and vehicle control systems. They withstand high usage and environmental challenges easily. Ideal for control panels, machinery, and transportation systems."
  },
  {
    id: 18,
    title: "Side Stick Controllers",
    img: ua,
    desc: " Side Stick Controllers offer high precision for pilot and operator control. Commonly used in aerospace, simulation, and defense systems. Their ergonomic design ensures comfort and responsiveness. Built to deliver accurate and smooth control under demanding use."
  },
];


export default function CrauzetPage() {
  return (
    <div
      style={{
        background:
          // "linear-gradient(135deg, rgba(28, 29, 31, 0.95), rgba(255, 255, 255, 0.9))",
          "white"
      }}
    >
      <h2
        style={{
          fontWeight: 600,
          textAlign: "center",
          marginBottom: "50px",
          paddingTop: "50px",
          color: "#074f86ff",
        }}
      >
        Railway Products
      </h2>

      <div className="crauzet-grid">
        {crauzetProducts.map((item) => (
          <div className="crauzet-card" key={item.id}>
            <img
              src={item.img}
              alt={item.title}
              style={{ height: "250px", width:"500px", objectFit: "" }}
            />
            <div className="crauzet-title">{item.title}</div>

            {/* description overlay appears only on hover */}
            <div className="crauzet-hover-desc">
              <p>{item.desc}</p>
              <Link to={`/crauzet/${item.id}`} className="crauzet-view-btn">
                View Product
              </Link>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export { crauzetProducts };
